import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

// Routes
import { useUserData } from "./context/UserDataContext.js";
import AdminRoutes from "./components/admin/shares/AdminRoutes.js";
import EndUserRoutes from "./components/end-user/routes/EndUserRoutes.js";

//................. Admin

const Authenticated = () => {
  const { userData } = useUserData();

  return (
    <>
      {userData.job == "Admin" && <AdminRoutes />}
      {userData.job == "TreatmentProvinceExpert" && <EndUserRoutes />}
      {userData.job == "TreatmentCityExpert" && <EndUserRoutes />}
      {userData.job == "TreatmentAreaExpert" && <EndUserRoutes />}

      {/* 1 */}
      {/* <Route path="/redirect" element={<Navigate to="/setting-ring" />} /> */}
      {/* 2 */}
      {/* <Route path="/setting/*" element={<Ring />} /> */}
      {/* in the Ring Component use the nested route like below: */}
      {/* <Routers>
        <Route path="/nested" element={<Nested />} />
      </Routers> */}
    </>
  );
};
export default Authenticated;
